import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-388f8254"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "offcanvas offcanvas-end task-sidebar",
  id: "taskSidebar",
  tabindex: "-1",
  "data-bs-backdrop": "true",
  "aria-labelledby": "offcanvasLabel",
  "aria-hidden": "true",
  "data-bs-scroll": "true"
}
const _hoisted_2 = { class: "modal-dialog h-100 mt-3" }
const _hoisted_3 = { class: "modal-content h-100" }
const _hoisted_4 = { class: "offcanvas-body" }
const _hoisted_5 = {
  key: 0,
  class: "show-context"
}
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center w-100" }
const _hoisted_7 = { class: "d-flex align-items-center flex-grow-1" }
const _hoisted_8 = {
  type: "button",
  class: "btn-close",
  "aria-label": "Close",
  ref: "closeBtn",
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#taskSidebar"
}
const _hoisted_9 = { class: "settings-wrapper mt-4" }
const _hoisted_10 = { class: "description" }
const _hoisted_11 = { class: "nav-wrapper" }
const _hoisted_12 = { class: "nav nav-tabs" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = {
  ref: "form-tab",
  class: "nav-link active",
  href: "#",
  id: "form-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#forms-view"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link",
    href: "#",
    id: "details-tab",
    "data-bs-toggle": "tab",
    "data-bs-target": "#details-view"
  }, "Details")
], -1))
const _hoisted_16 = {
  class: "tab-content mt-4",
  id: "myTabContent"
}
const _hoisted_17 = {
  class: "tab-pane fade show active",
  id: "forms-view",
  role: "tabpanel",
  "aria-labelledby": "home-tab"
}
const _hoisted_18 = {
  class: "tab-pane fade",
  id: "details-view",
  role: "tabpanel",
  "aria-labelledby": "profile-tab"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_settings_block_v2 = _resolveComponent("settings-block-v2")!
  const _component_WYSIWYGEditor = _resolveComponent("WYSIWYGEditor")!
  const _component_task_form_viewer = _resolveComponent("task-form-viewer")!
  const _component_calendly_view = _resolveComponent("calendly-view")!
  const _component_hubspot_meeting_view = _resolveComponent("hubspot-meeting-view")!
  const _component_details_block = _resolveComponent("details-block")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.hasTaskContext)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", {
                  class: "context cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToContext && _ctx.goToContext(...args)))
                }, "Show context")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("textarea", {
                class: "inline-headline-edit h6 w-100",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedHeadline) = $event)),
                placeholder: "Task headline",
                ref: "headlineTextarea",
                onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.adjustHeight && _ctx.adjustHeight(...args)))
              }, "\n              ", 544), [
                [_vModelText, _ctx.computedHeadline]
              ])
            ])
          ]),
          _createElementVNode("button", _hoisted_8, null, 512),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_settings_block_v2, {
              content: _ctx.selectedTask,
              isExecution: _ctx.isReadOnly
            }, null, 8, ["content", "isExecution"])
          ]),
          _createElementVNode("p", _hoisted_10, [
            (_openBlock(), _createBlock(_component_WYSIWYGEditor, {
              content: _ctx.computedDescription,
              "onUpdate:content": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedDescription) = $event)),
              key: _ctx.selectedTask.taskId,
              class: "mb-2",
              placeholder: "Add a description"
            }, null, 8, ["content"]))
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("ul", _hoisted_12, [
              _createElementVNode("li", _hoisted_13, [
                _createElementVNode("a", _hoisted_14, "Task", 512)
              ]),
              _hoisted_15
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              (_ctx.selectedTask.typeConfig && _ctx.selectedTask.typeConfig.FORM)
                ? (_openBlock(), _createBlock(_component_task_form_viewer, {
                    key: _ctx.renderKey,
                    formId: _ctx.selectedTask.typeConfig.FORM.formId,
                    blockId: _ctx.selectedTask.taskId,
                    moduleId: _ctx.selectedTask.moduleId,
                    config: _ctx.selectedTask.typeConfig.FORM,
                    onUpdateStatus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateStatus($event)))
                  }, null, 8, ["formId", "blockId", "moduleId", "config"]))
                : _createCommentVNode("", true),
              (_ctx.selectedTask.taskType == 'schedule' && _ctx.selectedTask.typeConfig.CALENDAR.type == 'CALENDLY')
                ? (_openBlock(), _createBlock(_component_calendly_view, {
                    key: 1,
                    link: _ctx.selectedTask.typeConfig.CALENDAR.link,
                    onDone: _cache[5] || (_cache[5] = ($event: any) => (_ctx.markAsDone()))
                  }, null, 8, ["link"]))
                : _createCommentVNode("", true),
              (_ctx.selectedTask.taskType == 'schedule' && _ctx.selectedTask.typeConfig.CALENDAR.type == 'HUBSPOT')
                ? (_openBlock(), _createBlock(_component_hubspot_meeting_view, {
                    key: 2,
                    link: _ctx.selectedTask.typeConfig.CALENDAR.link,
                    onDone: _cache[6] || (_cache[6] = ($event: any) => (_ctx.markAsDone()))
                  }, null, 8, ["link"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_details_block, { content: _ctx.selectedTask }, null, 8, ["content"])
            ])
          ])
        ])
      ])
    ])
  ]))
}